import * as types from "./types";

export const foodReportInitialState = {
  //get request for all role
  singleFood: <any>[],
  singleFoodLoading: false,
  singleFoodError: null,

  //canteen food total expense report
  cTotalExpenseReport: <any>[],
  cTotalExpenseReportError: null,

  // report from and to time
  fromDate: null,
  ToDate: null,

  //REPORT SECLECTION TYPE
  enlgishSelect: false,
  nepaliDate: false,
  englishDate: false,
};

export const foodReportReducer = (
  state = foodReportInitialState,
  action: any
) => {
  switch (action.type) {
    case types.SET_REPORT_BY_ENGLISH_SELECT:
      return {
        ...state,
        enlgishSelect: true,
        nepaliDate: false,
        englishDate: false,
      };
    case types.SET_ALL_REPORT_BY_FALSE:
      return {
        ...state,
        enlgishSelect: false,
        nepaliDate: false,
        englishDate: false,
      };
    case types.SET_REPORT_BY_NEPALI_DATE:
      return {
        ...state,
        enlgishSelect: false,
        nepaliDate: true,
        englishDate: false,
      };
    case types.UNSET_REPORT_BY_NEPALI_DATE:
      return {
        ...state,
        enlgishSelect: false,
        nepaliDate: false,
        englishDate: false,
      };

    case types.UNSET_REPORT_BY_ENGLISH_SELECT:
      return {
        ...state,
        enlgishSelect: false,
        nepaliDate: false,
        englishDate: false,
      };
    case types.UNSET_REPORT_BY_ENGLISH_DATE:
      return {
        ...state,
        enlgishSelect: false,
        nepaliDate: false,
        englishDate: false,
      };
    case types.SET_REPORT_BY_ENGLISH_DATE:
      return {
        ...state,
        enlgishSelect: false,
        nepaliDate: false,
        englishDate: true,
      };
    case types.SET_FROM_TIME:
      return {
        ...state,
        fromDate: action.fromDate,
      };
    case types.SET_TO_TIME:
      return {
        ...state,
        toDate: action.toDate,
      };

    case types.REMOVE_TO_TIME:
      return {
        ...state,
        toDate: null,
      };

    case types.REMOVE_FROM_TIME:
      return {
        ...state,
        fromDate: null,
      };

    case types.GET_SINGLE_FOOD_REPORT_START:
      return {
        ...state,
        singleFoodLoading: true,
      };
    case types.GET_SINGLE_FOOD_REPORT_SUCCESS:
      return {
        ...state,
        singleFood: action.singleFood,
        singleFoodLoading: false,
      };
    case types.GET_SINGLE_FOOD_REPORT_FAILURE:
      return {
        ...state,
        singleFoodError: action.singleFoodError,
        singleFoodLoading: false,
      };
    case types.GET_CFOOD_TOTAL_EXPENSE_REPORT:
      return {
        ...state,
        cTotalExpenseReport: action.cTotalExpenseReport,
      };
    case types.GET_CFOOD_TOTAL_EXPENSE_REPORT_FAILURE:
      return {
        ...state,
        cTotalExpenseReportError: action.cTotalExpenseReportError,
      };
    default:
      return state;
  }
};
